import React from 'react';

import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import DashboardMessages from 'components/DashboardMessages/DashboardMessages';
import { useIsLoggedIn } from 'hooks/useIsLoggedIn';

import AuctionDates from './components/AuctionDates/AuctionDates';
import AuctionVolumes from './components/AuctionVolumes/AuctionVolumes';
import LoggedInActions from './components/LoggedInActions/LoggedInActions';
import LoggedOutActions from './components/LoggedOutActions/LoggedOutActions';

import './ProsforaProjectPage.scss';

export interface ProsforaProjectPageProps {}

const ProsforaProjectPage = ({}: ProsforaProjectPageProps) => {
  const isLoggedIn = useIsLoggedIn();

  return (
    <div className="enkrateia-prosfora-dashboard">
      <Header />
      <div className="content">
        {isLoggedIn ? <LoggedInActions /> : <LoggedOutActions />}
        <DashboardMessages />
        <AuctionDates />
        <AuctionVolumes />
      </div>
      <Footer />
    </div>
  );
};

export default ProsforaProjectPage;
